import React from 'react';
import { TableColumn } from '../../../../ui/components/Common/DataTable/Table';
import { TooltipWrapper } from '../../../job_openings/view/Functions';
import type { ISecurityLog } from '../interfaces';

export const getSecurityLogColumns = (): TableColumn<ISecurityLog>[] => [
  {
    key: 'action',
    label: 'Action',
    width: '250px',
    align: 'left',
    render: (row: ISecurityLog) => <TooltipWrapper text={row.action} />,
  },
  {
    key: 'user',
    label: 'User',
    width: '150px',
    align: 'left',
    render: (row: ISecurityLog) => <TooltipWrapper text={row.user} />,
    disableSort: true,
  },
  {
    key: 'ip',
    label: 'IP Address',
    width: '150px',
    align: 'left',
    render: (row: ISecurityLog) => <TooltipWrapper text={row.ip} />,
    disableSort: true,
  },
  {
    key: 'timestamp',
    label: 'Timestamp',
    width: '200px',
    align: 'left',
    render: (row: ISecurityLog) => <TooltipWrapper text={row.timestamp} />,
    disableSort: true,
  },
];
